import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

//defines which balance is used for which masses.
//tends to be constant across all test types.
const getMeasuredUsingConfig = (prefix: string) => {
  const balance = wrap(`${prefix}.SamplingDetails.Balance`);
  return {
    [`${prefix}.SamplingDetails.SampleBags.SampleBags.BagMass`]: balance,
  };
};

export default getMeasuredUsingConfig;
